const {
  REACT_APP_API_URL,
  REACT_APP_WEB_URL,
  REACT_APP_GOOGLE_SITE_KEY,
  REACT_APP_TURNSTILE_SITE_KEY,
  ADMIN_MESSAGE_REFRESH_TIME,
  REACT_APP_WS_URL,
  REACT_APP_API_KEY,
  REACT_APP_AUTH_DOMAIN,
  REACT_APP_PROJECT_ID,
  REACT_APP_STORAGE_BUCKET,
  REACT_APP_MESSAGING_SENDER_ID,
  REACT_APP_APP_ID,
  REACT_APP_VAPID_KEY,
  REACT_APP_TIMEOUT,
  REACT_APP_KEEPLIVE_INSEC,
  REACT_APP_RETRY_ATTEMPTS,
  REACT_APP_IDLE_TIMEOUT_MS,
  REACT_APP_IDLE_WARNING_MS,
} = { ...window._env_ }

export const constants = {
  // Runtime config from env-config.js with localhost fallback for development
  LINK: `${REACT_APP_API_URL || 'http://localhost:5000'}/graphql`,
  API_URL: REACT_APP_API_URL || 'http://localhost:5000',
  TIMEOUT: REACT_APP_TIMEOUT || 5 * 60 * 60 * 1000, //5h
  KEEP_LIVE: REACT_APP_KEEPLIVE_INSEC || 10 * 1000, //10 secs
  // ── Clinician idle timeout ──────────────────────────────────────────────
  // Logs an UNATTENDED admin out. This is NOT the session cap: the JWT's own
  // 5h `exp` (TOKEN_EXPITATION_USER, server-side) still applies and is the
  // bound that matters for a stolen token or a revoked account. See
  // util/idletimeout.js for the full reasoning before changing either.
  //
  // Both carry a hardcoded default on purpose. env.sh writes env-config.js
  // from the lines of .env, so an absent variable never reaches the app at
  // all and a blank one arrives as "" -- either way the fallback applies and
  // the control stays on. Values arrive as STRINGS; util/idletimeout.js
  // parseDurationMs() coerces and rejects junk, so a typo degrades to the
  // default instead of becoming NaN and logging everyone out instantly.
  //
  // NOT the same knob as TIMEOUT above, which feeds the websocket link
  // (services/apollo/subscription.link.js) and is unrelated to idleness.
  IDLE_TIMEOUT_MS: REACT_APP_IDLE_TIMEOUT_MS || 30 * 60 * 1000, //30 min idle
  IDLE_WARNING_MS: REACT_APP_IDLE_WARNING_MS || 2 * 60 * 1000, //warn at 28 min
  SOCKET_RETRY_ATTEMPTS: REACT_APP_RETRY_ATTEMPTS || Infinity,
  WS_LINK: `${REACT_APP_WS_URL || 'ws://localhost:5000'}/graphql`,
  MESSAGING_API_KEY: REACT_APP_API_KEY,
  MESSAGING_AUTH_DOMAIN: REACT_APP_AUTH_DOMAIN,
  MESSAGING_PROJECT_ID: REACT_APP_PROJECT_ID,
  MESSAGING_STORAGE_BUCKET: REACT_APP_STORAGE_BUCKET,
  MESSAGING_SENDER_ID: REACT_APP_MESSAGING_SENDER_ID,
  MESSAGING_APP_ID: REACT_APP_APP_ID,
  MESSAGING_VAPID_KEY: REACT_APP_VAPID_KEY,
  APP_WEB_URL: REACT_APP_WEB_URL,
  AGE_GROUP: [
    [0, 29, '0-29'],
    [30, 40, '30-40'],
    [41, 50, '41-50'],
    [51, 60, '51-60'],
    [61, 70, '61-70'],
    [71, 80, '71-80'],
    [81, 200, '81+'],
  ],

  // Google reCAPTCHA. RETIRED 2026-08-13 — kept only so any straggling
  // reference still resolves. The public forms now use Cloudflare Turnstile
  // (below), matching the patient app. The prod2 value was malformed anyway
  // (39 chars; Google's are 40), which is why those forms hung on submit.
  GOOGLE_SITE_KEY: REACT_APP_GOOGLE_SITE_KEY,

  // Cloudflare Turnstile site key (public). Empty => the widget logs an error
  // and renders nothing; submissions are then rejected server-side, because
  // the public forms verify fail-CLOSED (see physio_server business/turnstile.js).
  TURNSTILE_SITE_KEY: REACT_APP_TURNSTILE_SITE_KEY || '',

  ADMIN_LITE:'?app=admin-lite',
  READ_MORE_LENGTH: 800,

  MOBILE_MAXWIDTH: 1024,
  SCORE: {
    PAIN_LEVEL: 'Pain Management',
    KNEE_SCORE: 'Functional Knee',
    FLEXION: 'Range Of Motion',
    PAIN_LEVEL_V2: 'Pain Level',
    KNEE_SCORE_v2: 'Knee Score',
    FLEXION_V2: 'Flexion',
    EXTENSION: 'Extension',
  },

  INTERVAL_OPTIONS: [
    { index: 1, name: 'Every Day' },
    { index: 2, name: 'Two Times Week' },
    { index: 3, name: 'Three Times Week' },
    { index: 4, name: 'Four Times Week' },
    { index: 5, name: 'Five Times Week' },
    { index: 6, name: 'Six Times Week' },
    { index: 7, name: 'Once A Week' },
  ],
  WEEKDAYS: [
    { index: 0, name: 'sunday', display_name: 'Sunday' },
    { index: 1, name: 'monday', display_name: 'Monday' },
    { index: 2, name: 'tuesday', display_name: 'Tuesday' },
    { index: 3, name: 'wednesday', display_name: 'Wednesday' },
    { index: 4, name: 'thursday', display_name: 'Thursday' },
    { index: 5, name: 'friday', display_name: 'Friday' },
    { index: 6, name: 'saturday', display_name: 'Saturday' },
  ],

  ACTION_CASE_TITLE: {
    NEW_PATIENT: 'New Patient',
    NEW_DEVICE_ORDER: 'New Device Order',
    PATIENT_TECHNICAL: 'Patient Technical',
    SYSTEM_TECHNICAL: 'System Technical',
    EXTERNAL_PATIENT: 'External Patient',
    DELETE_ACCOUNT_REQUEST: 'Delete Account Request',
    SURGEON_MESSAGE: 'Surgeon Message',
    MOVEAI_MESSAGE: 'MoveAI Message',
  },
  // Display name patients see on MoveAI Messages; the editable record lives
  // in the companies collection (issupportprofile) on the server.
  MOVEAI_SUPPORT_NAME: 'MoveAI Health Support',
  ACTION_CASE_STATUS: {
    ASSIGNED: 'Assigned',
    UNASSIGNED: 'Unassigned',
    RESOLVED: 'Resolved',
    UNRESOLVED: 'Unresolved',
    NOTANISSUE: 'NotAnIssue',
  },
  ACTION_CASE_BULK: {
    READ: 'read',
    UNREAD: 'unread',
    RESOLVE: 'resolve',
    UNRESOLVE: 'unresolve',
    NOTANISSUE: 'notanissue',
    ASSIGN: 'assign',
  },
  ACTION_CASE_PRIORITY: {
    ONE: 'P1',
    TWO: 'P2',
    THREE: 'P3',
    FOUR: 'P4',
    BLOCKER: 'Blocker',
    CRITICAL: 'Critical',
  },

  MESSAGE: {
    SUCCESS: 'success',
    FAIL: 'fail',
    TOKEN_EXPIRED: 'Token expired',
    // Wire status the server returns on every request while maintenance mode
    // is on (see physio_server constants.MAINTENANCE_STATUS).
    MAINTENANCE: 'MAINTENANCE',
    MAINTENANCE_LOGOUT:
      'Your session was ended because the system is undergoing maintenance. Please log in again once maintenance is complete.',
    MAINTENANCE_LOGIN_BANNER:
      'System maintenance in progress. The platform is temporarily offline for updates. Login will be available again as soon as maintenance is complete.',
    // Deliberately states no duration. The idle window is runtime-configurable
    // (IDLE_TIMEOUT_MS), and copy naming "30 minutes" would quietly become a
    // lie the first time that value changed. The warning modal shows a live
    // countdown, which cannot go stale.
    IDLE_LOGOUT:
      'You were signed out because the admin was left idle. Please log in again.',
    ORDER_PLACED:
      'Order for the devices has been received. Notification regarding the shipment of the device will be sent once devices are shipped.',
  },

  ROLE: {
    ADMIN: '1',
    PHYSIO: '2',
    SURGEON: '3',
    MEDICAL_ASSOCIATE: '4',
    PATIENT: '11',
    COMPANY_ADMIN: '21',
    COMPANY_HEALTHCOACH: '22',
    SUPER_ADMIN: '31',
    ANONYMOUS: '41',
    AUTHORIZED: '42',
  },

  GENDER: {
    M: 'male',
    F: 'female',
  },

  SURGERYTIME: {
    Pre: 'Pre-Op',
    Post: 'Post-Op',
    All: 'ALL',
  },

  // REMOVED — this was the server's JWT SIGNING SECRET, hardcoded here and so
  // shipped in the browser bundle. Anyone could extract it from main.*.js and
  // forge a token for any user and any role. util.verifyToken now decodes
  // without a secret (the API verifies server-side, which is the check that
  // matters). Do NOT reintroduce a secret in this file. See docs/BUGS.md.
  //
  // ⚠️ The old value must be treated as COMPROMISED: it has been public in every
  // deployed admin bundle. Any environment whose server SECRET still equals it
  // can have tokens forged until that SECRET is rotated.

  MAIL: {
    MESSAGE: "<p>Greetings. Here's the patient progress report.</p>",
    SUBJECT: (name) => `User report for ${name}`,
  },

  YEAR_TAG: 'YYYY',
  COPYRIGHT: {
    TEXT: (date) =>
      `© ${date} MoveAI LLC. All rights reserved. Patents pending.`,
  },
  DATE_FORMAT:{
     FORMAT1:'MMMM D, YYYY',
     FORMAT2:'MMM D, h:mm A',
  },
  APPLICATION:{
    AdminLite:'AdminLite',
    AdminWeb :'AdminWeb',

  },
  USA_STATE: [
 'Alabama',
'Alaska',
'Arizona',
'Arkansas',
'California',
'Colorado',
'Connecticut',
'Delaware',
'District of Columbia',
'Florida',
'Georgia',
'Hawaii',
'Idaho',
'Illinois',
'Indiana',
'Iowa',
'Kansas',
'Kentucky',
'Louisiana',
'Maine',
'Maryland',
'Massachusetts',
'Michigan',
'Minnesota',
'Mississippi',
'Missouri',
'Montana',
'Nebraska',
'Nevada',
'New Hampshire',
'New Jersey',
'New Mexico',
'New York',
'North Carolina',
'North Dakota',
'Ohio',
'Oklahoma',
'Oregon',
'Pennsylvania',
'Puerto Rico',
'Rhode Island',
'South Carolina',
'South Dakota',
'Tennessee',
'Texas',
'Utah',
'Vermont',
'Virginia',
'Virgin Islands',
'Washington',
'West Virginia',
'Wisconsin',
'Wyoming',
  ],

  COUNTRYS: [
    { name: 'Afghanistan', code: 'AF' },
    { name: 'land Islands', code: 'AX' },
    { name: 'Albania', code: 'AL' },
    { name: 'Algeria', code: 'DZ' },
    { name: 'American Samoa', code: 'AS' },
    { name: 'AndorrA', code: 'AD' },
    { name: 'Angola', code: 'AO' },
    { name: 'Anguilla', code: 'AI' },
    { name: 'Antarctica', code: 'AQ' },
    { name: 'Antigua and Barbuda', code: 'AG' },
    { name: 'Argentina', code: 'AR' },
    { name: 'Armenia', code: 'AM' },
    { name: 'Aruba', code: 'AW' },
    { name: 'Australia', code: 'AU' },
    { name: 'Austria', code: 'AT' },
    { name: 'Azerbaijan', code: 'AZ' },
    { name: 'Bahamas', code: 'BS' },
    { name: 'Bahrain', code: 'BH' },
    { name: 'Bangladesh', code: 'BD' },
    { name: 'Barbados', code: 'BB' },
    { name: 'Belarus', code: 'BY' },
    { name: 'Belgium', code: 'BE' },
    { name: 'Belize', code: 'BZ' },
    { name: 'Benin', code: 'BJ' },
    { name: 'Bermuda', code: 'BM' },
    { name: 'Bhutan', code: 'BT' },
    { name: 'Bolivia', code: 'BO' },
    { name: 'Bosnia and Herzegovina', code: 'BA' },
    { name: 'Botswana', code: 'BW' },
    { name: 'Bouvet Island', code: 'BV' },
    { name: 'Brazil', code: 'BR' },
    { name: 'British Indian Ocean Territory', code: 'IO' },
    { name: 'Brunei Darussalam', code: 'BN' },
    { name: 'Bulgaria', code: 'BG' },
    { name: 'Burkina Faso', code: 'BF' },
    { name: 'Burundi', code: 'BI' },
    { name: 'Cambodia', code: 'KH' },
    { name: 'Cameroon', code: 'CM' },
    { name: 'Canada', code: 'CA' },
    { name: 'Cape Verde', code: 'CV' },
    { name: 'Cayman Islands', code: 'KY' },
    { name: 'Central African Republic', code: 'CF' },
    { name: 'Chad', code: 'TD' },
    { name: 'Chile', code: 'CL' },
    { name: 'China', code: 'CN' },
    { name: 'Christmas Island', code: 'CX' },
    { name: 'Cocos (Keeling) Islands', code: 'CC' },
    { name: 'Colombia', code: 'CO' },
    { name: 'Comoros', code: 'KM' },
    { name: 'Congo', code: 'CG' },
    { name: 'Congo, The Democratic Republic of the', code: 'CD' },
    { name: 'Cook Islands', code: 'CK' },
    { name: 'Costa Rica', code: 'CR' },
    { name: 'Cote DIvoire', code: 'CI' },
    { name: 'Croatia', code: 'HR' },
    { name: 'Cuba', code: 'CU' },
    { name: 'Cyprus', code: 'CY' },
    { name: 'Czech Republic', code: 'CZ' },
    { name: 'Denmark', code: 'DK' },
    { name: 'Djibouti', code: 'DJ' },
    { name: 'Dominica', code: 'DM' },
    { name: 'Dominican Republic', code: 'DO' },
    { name: 'Ecuador', code: 'EC' },
    { name: 'Egypt', code: 'EG' },
    { name: 'El Salvador', code: 'SV' },
    { name: 'Equatorial Guinea', code: 'GQ' },
    { name: 'Eritrea', code: 'ER' },
    { name: 'Estonia', code: 'EE' },
    { name: 'Ethiopia', code: 'ET' },
    { name: 'Falkland Islands (Malvinas)', code: 'FK' },
    { name: 'Faroe Islands', code: 'FO' },
    { name: 'Fiji', code: 'FJ' },
    { name: 'Finland', code: 'FI' },
    { name: 'France', code: 'FR' },
    { name: 'French Guiana', code: 'GF' },
    { name: 'French Polynesia', code: 'PF' },
    { name: 'French Southern Territories', code: 'TF' },
    { name: 'Gabon', code: 'GA' },
    { name: 'Gambia', code: 'GM' },
    { name: 'Georgia', code: 'GE' },
    { name: 'Germany', code: 'DE' },
    { name: 'Ghana', code: 'GH' },
    { name: 'Gibraltar', code: 'GI' },
    { name: 'Greece', code: 'GR' },
    { name: 'Greenland', code: 'GL' },
    { name: 'Grenada', code: 'GD' },
    { name: 'Guadeloupe', code: 'GP' },
    { name: 'Guam', code: 'GU' },
    { name: 'Guatemala', code: 'GT' },
    { name: 'Guernsey', code: 'GG' },
    { name: 'Guinea', code: 'GN' },
    { name: 'Guinea-Bissau', code: 'GW' },
    { name: 'Guyana', code: 'GY' },
    { name: 'Haiti', code: 'HT' },
    { name: 'Heard Island and Mcdonald Islands', code: 'HM' },
    { name: 'Holy See (Vatican City State)', code: 'VA' },
    { name: 'Honduras', code: 'HN' },
    { name: 'Hong Kong', code: 'HK' },
    { name: 'Hungary', code: 'HU' },
    { name: 'Iceland', code: 'IS' },
    { name: 'India', code: 'IN' },
    { name: 'Indonesia', code: 'ID' },
    { name: 'Iran, Islamic Republic Of', code: 'IR' },
    { name: 'Iraq', code: 'IQ' },
    { name: 'Ireland', code: 'IE' },
    { name: 'Isle of Man', code: 'IM' },
    { name: 'Israel', code: 'IL' },
    { name: 'Italy', code: 'IT' },
    { name: 'Jamaica', code: 'JM' },
    { name: 'Japan', code: 'JP' },
    { name: 'Jersey', code: 'JE' },
    { name: 'Jordan', code: 'JO' },
    { name: 'Kazakhstan', code: 'KZ' },
    { name: 'Kenya', code: 'KE' },
    { name: 'Kiribati', code: 'KI' },
    { name: 'Korea, Democratic PeopleS Republic of', code: 'KP' },
    { name: 'Korea, Republic of', code: 'KR' },
    { name: 'Kuwait', code: 'KW' },
    { name: 'Kyrgyzstan', code: 'KG' },
    { name: 'Lao PeopleS Democratic Republic', code: 'LA' },
    { name: 'Latvia', code: 'LV' },
    { name: 'Lebanon', code: 'LB' },
    { name: 'Lesotho', code: 'LS' },
    { name: 'Liberia', code: 'LR' },
    { name: 'Libyan Arab Jamahiriya', code: 'LY' },
    { name: 'Liechtenstein', code: 'LI' },
    { name: 'Lithuania', code: 'LT' },
    { name: 'Luxembourg', code: 'LU' },
    { name: 'Macao', code: 'MO' },
    { name: 'Macedonia, The Former Yugoslav Republic of', code: 'MK' },
    { name: 'Madagascar', code: 'MG' },
    { name: 'Malawi', code: 'MW' },
    { name: 'Malaysia', code: 'MY' },
    { name: 'Maldives', code: 'MV' },
    { name: 'Mali', code: 'ML' },
    { name: 'Malta', code: 'MT' },
    { name: 'Marshall Islands', code: 'MH' },
    { name: 'Martinique', code: 'MQ' },
    { name: 'Mauritania', code: 'MR' },
    { name: 'Mauritius', code: 'MU' },
    { name: 'Mayotte', code: 'YT' },
    { name: 'Mexico', code: 'MX' },
    { name: 'Micronesia, Federated States of', code: 'FM' },
    { name: 'Moldova, Republic of', code: 'MD' },
    { name: 'Monaco', code: 'MC' },
    { name: 'Mongolia', code: 'MN' },
    { name: 'Montenegro', code: 'ME' },
    { name: 'Montserrat', code: 'MS' },
    { name: 'Morocco', code: 'MA' },
    { name: 'Mozambique', code: 'MZ' },
    { name: 'Myanmar', code: 'MM' },
    { name: 'Namibia', code: 'NA' },
    { name: 'Nauru', code: 'NR' },
    { name: 'Nepal', code: 'NP' },
    { name: 'Netherlands', code: 'NL' },
    { name: 'Netherlands Antilles', code: 'AN' },
    { name: 'New Caledonia', code: 'NC' },
    { name: 'New Zealand', code: 'NZ' },
    { name: 'Nicaragua', code: 'NI' },
    { name: 'Niger', code: 'NE' },
    { name: 'Nigeria', code: 'NG' },
    { name: 'Niue', code: 'NU' },
    { name: 'Norfolk Island', code: 'NF' },
    { name: 'Northern Mariana Islands', code: 'MP' },
    { name: 'Norway', code: 'NO' },
    { name: 'Oman', code: 'OM' },
    { name: 'Pakistan', code: 'PK' },
    { name: 'Palau', code: 'PW' },
    { name: 'Palestinian Territory, Occupied', code: 'PS' },
    { name: 'Panama', code: 'PA' },
    { name: 'Papua New Guinea', code: 'PG' },
    { name: 'Paraguay', code: 'PY' },
    { name: 'Peru', code: 'PE' },
    { name: 'Philippines', code: 'PH' },
    { name: 'Pitcairn', code: 'PN' },
    { name: 'Poland', code: 'PL' },
    { name: 'Portugal', code: 'PT' },
    { name: 'Puerto Rico', code: 'PR' },
    { name: 'Qatar', code: 'QA' },
    { name: 'Reunion', code: 'RE' },
    { name: 'Romania', code: 'RO' },
    { name: 'Russian Federation', code: 'RU' },
    { name: 'RWANDA', code: 'RW' },
    { name: 'Saint Helena', code: 'SH' },
    { name: 'Saint Kitts and Nevis', code: 'KN' },
    { name: 'Saint Lucia', code: 'LC' },
    { name: 'Saint Pierre and Miquelon', code: 'PM' },
    { name: 'Saint Vincent and the Grenadines', code: 'VC' },
    { name: 'Samoa', code: 'WS' },
    { name: 'San Marino', code: 'SM' },
    { name: 'Sao Tome and Principe', code: 'ST' },
    { name: 'Saudi Arabia', code: 'SA' },
    { name: 'Senegal', code: 'SN' },
    { name: 'Serbia', code: 'RS' },
    { name: 'Seychelles', code: 'SC' },
    { name: 'Sierra Leone', code: 'SL' },
    { name: 'Singapore', code: 'SG' },
    { name: 'Slovakia', code: 'SK' },
    { name: 'Slovenia', code: 'SI' },
    { name: 'Solomon Islands', code: 'SB' },
    { name: 'Somalia', code: 'SO' },
    { name: 'South Africa', code: 'ZA' },
    { name: 'South Georgia and the South Sandwich Islands', code: 'GS' },
    { name: 'Spain', code: 'ES' },
    { name: 'Sri Lanka', code: 'LK' },
    { name: 'Sudan', code: 'SD' },
    { name: 'Suriname', code: 'SR' },
    { name: 'Svalbard and Jan Mayen', code: 'SJ' },
    { name: 'Swaziland', code: 'SZ' },
    { name: 'Sweden', code: 'SE' },
    { name: 'Switzerland', code: 'CH' },
    { name: 'Syrian Arab Republic', code: 'SY' },
    { name: 'Taiwan, Province of China', code: 'TW' },
    { name: 'Tajikistan', code: 'TJ' },
    { name: 'Tanzania, United Republic of', code: 'TZ' },
    { name: 'Thailand', code: 'TH' },
    { name: 'Timor-Leste', code: 'TL' },
    { name: 'Togo', code: 'TG' },
    { name: 'Tokelau', code: 'TK' },
    { name: 'Tonga', code: 'TO' },
    { name: 'Trinidad and Tobago', code: 'TT' },
    { name: 'Tunisia', code: 'TN' },
    { name: 'Turkey', code: 'TR' },
    { name: 'Turkmenistan', code: 'TM' },
    { name: 'Turks and Caicos Islands', code: 'TC' },
    { name: 'Tuvalu', code: 'TV' },
    { name: 'Uganda', code: 'UG' },
    { name: 'Ukraine', code: 'UA' },
    { name: 'United Arab Emirates', code: 'AE' },
    { name: 'United Kingdom', code: 'GB' },
    { name: 'United States', code: 'US' },
    { name: 'United States Minor Outlying Islands', code: 'UM' },
    { name: 'Uruguay', code: 'UY' },
    { name: 'Uzbekistan', code: 'UZ' },
    { name: 'Vanuatu', code: 'VU' },
    { name: 'Venezuela', code: 'VE' },
    { name: 'Viet Nam', code: 'VN' },
    { name: 'Virgin Islands, British', code: 'VG' },
    { name: 'Virgin Islands, U.S.', code: 'VI' },
    { name: 'Wallis and Futuna', code: 'WF' },
    { name: 'Western Sahara', code: 'EH' },
    { name: 'Yemen', code: 'YE' },
    { name: 'Zambia', code: 'ZM' },
    { name: 'Zimbabwe', code: 'ZW' },
  ],
  AWS_FOLDER_NAME:{
    MESSAGE:"message",
  },
  message_refresh_time: ADMIN_MESSAGE_REFRESH_TIME || 5, //refresh message page in every 5 min
}
